import { LoaderActions } from '@store/loaders'
import {
  type DashboardActions,
  InternalDashboardActions,
} from '@store/reducers/dashboard/actions'
import {
  ErrorNotification,
  GeneralErrorNotification,
} from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import API from '@/api'

// Keep in sync with the "5 MB max" hint in AvatarInfo
const MAX_AVATAR_SIZE = 5 * 1024 * 1024

interface UploadResult {
  avatar: string
}
export function* updateAvatar({
  payload,
}: ReturnType<typeof DashboardActions.teams.updateAvatar>) {
  const { workspaceId, files } = payload

  if (files[0].size > MAX_AVATAR_SIZE) {
    yield put(ErrorNotification('Image is too large, 5 MB max'))
    return
  }

  yield put(LoaderActions.set('team_avatar_upload'))
  try {
    // @ts-expect-error
    const { avatar }: UploadResult = yield call(API.Team.addAvatar, {
      teamId: workspaceId,
      payload: { file: files[0] },
    })
    yield put(
      InternalDashboardActions.update({ workspaceId, data: { avatar } })
    )
  } catch (e) {
    console.error('Team avatar uploading', e)
    yield put(GeneralErrorNotification)
  } finally {
    yield put(LoaderActions.unset('team_avatar_upload'))
  }
}
